import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { DisplayField } from '../../components/DisplayField';
import { rendererContainer } from './styles/commonRendererStyles';
import type { AutomationStepNodeData } from '../../types/stepNodes';

interface TagStepRendererProps {
	nodeId: string;
	data: AutomationStepNodeData;
	readOnly?: boolean;
}

export function TagStepRenderer({ nodeId: _nodeId, data, readOnly: readOnlyProp }: TagStepRendererProps) {
	const { automationStep, stepData } = data;
	const tagStep = automationStep as Api.IAddTagAutomationStep | Api.IRemoveTagAutomationStep;
	const stepType = data.stepType;
	const tagName: string = tagStep?.tagName || (stepData?.tagName as string | undefined) || '';

	const isAddTag = stepType === Api.AutomationStepType.AddTag;

	return (
		<div className={css(rendererContainer)}>
			<DisplayField
				label={isAddTag ? 'Add tag:' : 'Remove tag:'}
				value={tagName}
				required
				readOnly={readOnlyProp}
				placeholder={readOnlyProp ? 'No tag selected' : 'Tag name will appear here'}
			/>
		</div>
	);
}
